import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { UserProfile } from '@lyceo/shared/auth/util-models';
import * as AuthSelectors from './auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthFacade {
  private readonly store: Store = inject(Store);

  public readonly isAuthenticated: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectIsAuthenticated,
  );
  public readonly loginError: Signal<string | null> = this.store.selectSignal(
    AuthSelectors.selectLoginError,
  );
  public readonly hasLoginError: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectHasLoginError,
  );
  public readonly isDoneLoading: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectIsDoneLoading,
  );
  public readonly userProfile: Signal<UserProfile | undefined> =
    this.store.selectSignal(AuthSelectors.selectUserProfile);
  public readonly userId: Signal<string | undefined> = this.store.selectSignal(
    AuthSelectors.selectUserId,
  );
  public readonly userEmail: Signal<string | undefined> =
    this.store.selectSignal(AuthSelectors.selectUserEmail);
  public readonly userFullName: Signal<string | undefined> =
    this.store.selectSignal(AuthSelectors.selectUserFullName);
  public readonly userRoles: Signal<string[]> = this.store.selectSignal(
    AuthSelectors.selectUserRoles,
  );
  public readonly showLoader: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectShowLoader,
  );

  public login(kcIdpHint?: 'entree'): void {
    this.store.dispatch(AuthActions.login({ kcIdpHint }));
  }

  public mobileTryLogin(urlSearch: string): void {
    this.store.dispatch(AuthActions.mobileTryLogin({ urlSearch }));
  }

  public mobileLogoutFinish(): void {
    this.store.dispatch(AuthActions.mobileLogoutFinish());
  }

  public userLogout(): void {
    this.store.dispatch(AuthActions.userLogout());
  }

  public retryLoadDiscoveryDocument(): void {
    this.store.dispatch(AuthActions.retryLoadDiscoveryDocument());
  }
}
